
export type TweetFeedResponseTweetsItemContent = {
  mentions?: string[];
  /**
   * @maxLength 280
   * @nullable
   */
  text?: string | null;
};
